import { apiRequest } from '../http.js'

export const notesApi = {
getAll: async ({ userId, campaignId } = {}, options = {}) => {
      const qs = new URLSearchParams()
      qs.set('userId', userId)
      if (campaignId) qs.set('campaignId', campaignId)
      const data = await apiRequest(`/notes?${qs.toString()}`, options)
      return data.notes || []
    },
    
    create: async (body, options = {}) => {
      const data = await apiRequest('/notes', {
        ...options,
        method: 'POST',
        body: JSON.stringify(body),
      })
      return data.note
    },
    delete: async (id, options = {}) => {
      await apiRequest(`/notes/${id}`, { ...options, method: 'DELETE' })
    },
}
